import { PUSH_PREFERENCES_API_URL, PUSH_PUBLIC_KEY_API_URL, PUSH_SUBSCRIPTIONS_API_URL } from "./constants";

const getAuthHeaders = () => {
  const accessToken = localStorage.getItem("access");
  return accessToken ? { Authorization: `Bearer ${accessToken}` } : {};
};

const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; i += 1) {
    outputArray[i] = rawData.charCodeAt(i);
  }

  return outputArray;
};

const getPushPublicKey = async () => {
  const response = await fetch(PUSH_PUBLIC_KEY_API_URL, {
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    return "";
  }

  const data = await response.json();
  return data.publicKey || "";
};

export const updatePushNotificationPreference = async (enabled) => {
  const response = await fetch(PUSH_PREFERENCES_API_URL, {
    method: "PATCH",
    headers: {
      ...getAuthHeaders(),
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ enabled }),
  });

  if (!response.ok) {
    throw new Error("Failed to update notification preference.");
  }

  return response.json();
};

export const ensurePushSubscription = async () => {
  if (!("serviceWorker" in navigator) || !("PushManager" in window) || !("Notification" in window)) {
    return;
  }

  const publicKey = await getPushPublicKey();
  if (!publicKey) {
    return;
  }

  const registration = await navigator.serviceWorker.ready;
  let subscription = await registration.pushManager.getSubscription();

  if (!subscription) {
    if (Notification.permission === "denied") {
      return;
    }

    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      return;
    }

    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    });
  }

  await fetch(PUSH_SUBSCRIPTIONS_API_URL, {
    method: "POST",
    headers: {
      ...getAuthHeaders(),
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      endpoint: subscription.endpoint,
      keys: subscription.toJSON().keys || {},
      user_agent: navigator.userAgent,
    }),
  });
};

export const unsubscribePushSubscription = async () => {
  if (!("serviceWorker" in navigator)) {
    return;
  }

  const registration = await navigator.serviceWorker.ready;
  const subscription = await registration.pushManager.getSubscription();

  if (!subscription) {
    return;
  }

  try {
    await fetch(PUSH_SUBSCRIPTIONS_API_URL, {
      method: "DELETE",
      headers: {
        ...getAuthHeaders(),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ endpoint: subscription.endpoint }),
    });
  } finally {
    await subscription.unsubscribe();
  }
};
